import "/src/app/tailwind.css?transform-only";export default "__VITE_CSS_URL__2f7372632f6170702f7461696c77696e642e6373733f7472616e73666f726d2d6f6e6c79__"